import { FormControl, FormHelperText, Input } from "@mui/joy";
import React, { useEffect, useRef, useState } from "react";
import { Accordion, Button, Form, FormLabel } from "react-bootstrap";
import { upload_sell_item_photo } from "../../reduxData/user/userAction";
import { Link } from "react-router-dom";
import Buying from "./Buying";
import Selling from "./Selling";
import Finalizing from "./Finalizing";
import SellingContent from "./HowItWorking/SellingContent";
import BuyingContent from "./HowItWorking/BuyingContent";
import FinalizingContent from "./HowItWorking/FinalizingContent";
import { useSelector } from "react-redux";
import { create_faq_question, get_top_image_how_it_works, upload_cms_photo } from "../../reduxData/cms/cmsAction";

const { REACT_APP_BASE_URL } = process.env;

const HowItWorks = () => {
    const [currentTab, setCurrentTab] = useState("buying");
    const [details,setDetails]=useState([]);
    const [topImage, setTopImage] = useState("");
    const [imgErr, setImgErr] = useState(false);
    const currentPage = JSON.parse(localStorage.getItem("currentTabb"));
    useEffect(() => {
        if (currentPage) {
            setCurrentTab(currentPage);
        } else {
            setCurrentTab("buying");
        }
    }, []);

    const imageRef = useRef();
    const handleImage = async (e) => {
        const fileUpload = [e.target.files[0]];
        let pathurl = '';

        const photoData = await upload_cms_photo(fileUpload, localStorage.getItem("token"));
        if (photoData !== undefined) {
            pathurl = photoData?.data?.photos[0];
        }

        setTopImage(pathurl);
        setImgErr(false);
    };

    const handleSave = async(e) => {
        e.preventDefault();
        setImgErr(topImage === "" ? true : false);

        if(topImage !== ""){
            const content = {
                name: 'image_how_it_works',
                type: 'image_how_it_works',
                status: true,
                content: {
                    topImage: topImage
                },
            };
            await create_faq_question(localStorage.getItem("token"), content, details[0]?._id);
        }
    };

    useEffect(() => {
        const handleUpdate = async () => {
            const data = await get_top_image_how_it_works(localStorage.getItem("token"), "image_how_it_works");
            if(data){
                setTopImage(data[0]?.content?.topImage);
                setDetails(data);
            }
        };
        handleUpdate();
    }, []);

    return (
        <div className="mt-2">
            <div className="container">
                <h3 className="mb-2 fw-600">How It Works</h3>
                <Form onSubmit={(e) => handleSave(e)}>
                    <h4 className="mb-2 fw-600 pt-2">Top Image</h4>
                    <FormControl className="mt-2 mb-4">
                        <div className="col-md-12 col-lg-12">
                            <div className="d-flex mb-2">
                                {topImage !== "" && <img
                                    src={`${topImage}`}
                                    style={{
                                        height: '300px',
                                        width: '100%'
                                    }}
                                />}
                                {topImage !== "" && <div className="position-relative upload-file-close">
                                    <button
                                        type="button"
                                        className="btn btn-sm rounded-circle"
                                        onClick={() => {
                                            setTopImage("");
                                            setImgErr(true);
                                        }}>
                                        <i class="fa-solid fa-xmark color-white"></i>
                                    </button>
                                </div>}
                            </div>
                            <input
                                type="file"
                                className="d-none"
                                accept='image/png, image/jpeg, image/jpg, image/gif'
                                ref={imageRef}
                                onChange={handleImage}
                            />
                            <Button className="btn content-button" onClick={() => { imageRef.current.click(); }}>
                                Upload Image
                            </Button>
                        </div>
                        {imgErr && (<FormHelperText style={{ color: 'red' }}>Top Image is required</FormHelperText>)}

                    </FormControl>
                    <Button type="submit" className="btn common-button">Save</Button>
                </Form>

                <h4 className="mb-3 fw-600 mt-5">Content (Buying/Selling/Finalizing)</h4>

                <div className="d-flex justify-content-between">
                    <div className="col-lg-8 col-md-8 pt-2">
                        <div className="text-md-end">
                            <ul className="list-inline mb-0 sorting-list">
                                <li className="list-inline-item mb-2 mb-md-0">
                                    <Link
                                        className={`text-decoration-none border rounded-pill px-3 py-2 ${currentTab === 'buying' ? 'active' : ''}`}
                                        onClick={() => { setCurrentTab("buying"); localStorage.setItem("currentTabb", JSON.stringify("buying")); }}
                                    >
                                        Buying a collectible
                                    </Link>
                                </li>
                                <li className="list-inline-item mb-2 mb-md-0">
                                    <Link
                                        className={`text-decoration-none border rounded-pill px-3 py-2 ${currentTab === 'selling' ? 'active' : ''}`}
                                        onClick={() => { setCurrentTab("selling"); localStorage.setItem("currentTabb", JSON.stringify("selling")); }}
                                    >
                                        Selling a collectible
                                    </Link>
                                </li>
                                <li className="list-inline-item mb-2 mb-md-0">
                                    <Link
                                        className={`text-decoration-none border rounded-pill px-3 py-2 ${currentTab === 'finalizing' ? 'active' : ''}`}
                                        onClick={() => { setCurrentTab("finalizing"); localStorage.setItem("currentTabb", JSON.stringify("finalizing")); }}
                                    >
                                        Finalizing the sale
                                    </Link>
                                </li>
                            </ul>
                        </div>{" "}
                    </div>
                </div>

                {(currentTab == 'buying') ? <BuyingContent />
                    : (currentTab == 'selling') ? <SellingContent />
                        : (currentTab == 'finalizing') ? <FinalizingContent />
                            : 'No Data Found'
                }

            </div>
        </div>
    )
};

export default HowItWorks;
